// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.global-settings-input-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.global-settings-input-wrapper .p-inputnumber {
  width: 100% !important;
  max-width: 100% !important;
}

.global-settings-input-wrapper .p-inputnumber .p-inputnumber-input {
  width: 100% !important;
  max-width: 100% !important;
  box-sizing: border-box !important;
}

.globalSettings-row {
  height: 42px;
}
`, "",{"version":3,"sources":["webpack://./src/ui/css/GlobalSettingsDialog.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;EACE,YAAY;AACd","sourcesContent":[".global-settings-input-wrapper {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.global-settings-input-wrapper .p-inputnumber {\n  width: 100% !important;\n  max-width: 100% !important;\n}\n\n.global-settings-input-wrapper .p-inputnumber .p-inputnumber-input {\n  width: 100% !important;\n  max-width: 100% !important;\n  box-sizing: border-box !important;\n}\n\n.globalSettings-row {\n  height: 42px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
